import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

export default createServiceProvider({
  ...getServiceProvider('notion'),
  requiresOAuthFlow: true,
  defaultAuthenticationType: 'oauth2Bearer',
  avatarPath: avatars.notion,
  logoPath: logos.notion,
  experimental: true
});
